
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M2.306.625h13.286c.236 0 .428.187.428.417v2.083H1.877V1.042c0-.23.192-.417.429-.417zm13.714 2.5H1.877L.645 18.702a.632.632 0 00.641.673h4.52c.325 0 .6-.237.638-.552l1.07-8.833c.09-.77.807-1.324 1.6-1.236a1.426 1.426 0 011.27 1.236l1.07 8.833a.637.637 0 00.638.552h4.52c.355 0 .643-.28.643-.625l-.002-.048L16.02 3.125z"}}),_c('path',{attrs:{"d":"M1.533 7.475c.113.017.228.025.343.025 1.777 0 3.216-1.959 3.216-4.375H1.877l-.344 4.35zm14.832 0a2.373 2.373 0 01-.343.025c-1.777 0-3.216-1.959-3.216-4.375h3.215l.344 4.35zm-8.059-4.35v2.5c0 .345.288.625.643.625h.643"}})])])
          )
        }
      }
    